<div class="fluid-container p-3 recharge-coupon-wrapper">

  <!-- Scrollable Tab Bar (Matching Configuration Component) -->
  <div class="scrollnavbar card-header d-flex justify-content-between align-items-center flex-wrap p-2 mb-3">
    <button class="scroll-btn" (click)="scrollLeft()" [disabled]="isAtLeft" type="button" aria-label="Scroll Left">
      ◀
    </button>
    <div class="nav-wrapper" #scrollContainer>
      <ul class="nav" id="coupon-pills-tab" role="tablist" ngbNav #nav="ngbNav"
        [(activeId)]="activeTab" (navChange)="onTabChange($event)">
        <li class="nav-item" *ngFor="let tab of tabs" [ngbNavItem]="tab.id">
          <a class="nav-link d-inline-flex align-items-center gap-2" ngbNavLink>
            <i *ngIf="tab.icon" [class]="tab.icon"></i>
            <span>{{ tab.name }}</span>
          </a>
          <ng-template ngbNavContent>
            <!-- ========================================== -->
            <!-- TAB 1: GENERATE COUPON                    -->
            <!-- ========================================== -->
            <div *ngIf="tab.id === 'generate_coupon'" class="tab-pane-container fade-in">
              <div class="card coupon-card shadow-sm">
                <div class="card-header filter d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa fa-ticket text-primary fs-5"></i>
                    <span class="filterspan">Generate Coupon</span>
                  </div>
                </div>

                <div class="card-body p-4">
                  <app-form-setup id="generateCouponForm" [FromJson]="generateFormConfig"
                    (formEmitted)="onGenerateFormEmitted($event)" (formCheck)="onGenerateFormCheck($event)"
                    [submitForm]="callForGenerateForm">
                  </app-form-setup>

                  <div class="d-flex align-items-center justify-content-end gap-2 pt-3 border-top">
                    <button type="button" (click)="triggerGenerateSubmit()"
                      class="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2"
                      [disabled]="isGenerating || !siteid">
                      <span *ngIf="isGenerating" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <i *ngIf="!isGenerating" class="fa fa-paper-plane"></i>
                      <span>{{ isGenerating ? 'Generating...' : 'Generate Coupon' }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ========================================== -->
            <!-- TAB 2: PRINT COUPON                       -->
            <!-- ========================================== -->
            <div *ngIf="tab.id === 'print_coupon'" class="tab-pane-container fade-in">
              <div class="card coupon-card shadow-sm">
                <div class="card-header filter d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa fa-print text-success fs-5"></i>
                    <span class="filterspan">Print Coupon</span>
                  </div>
                </div>

                <div class="card-body p-4">
                  <app-form-setup id="printCouponForm" [FromJson]="printFormConfig"
                    (formEmitted)="onPrintFormEmitted($event)" (formCheck)="onPrintFormCheck($event)"
                    [submitForm]="callForPrintForm">
                  </app-form-setup>

                  <div class="d-flex align-items-center justify-content-end gap-2 pt-3 border-top">
                    <button type="button" (click)="triggerPrintSubmit()"
                      class="btn btn-success d-inline-flex align-items-center gap-2 px-4 py-2"
                      [disabled]="isPrinting || !siteid">
                      <span *ngIf="isPrinting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <i *ngIf="!isPrinting" class="fa fa-print"></i>
                      <span>{{ isPrinting ? 'Printing...' : 'Print Coupon' }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ========================================== -->
            <!-- TAB 3: DISCARD COUPON (SINGLE)            -->
            <!-- ========================================== -->
            <div *ngIf="tab.id === 'coupon_discard'" class="tab-pane-container fade-in">
              <div class="card coupon-card shadow-sm">
                <div class="card-header filter d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa fa-ban text-danger fs-5"></i>
                    <span class="filterspan">Discard Coupon</span>
                  </div>
                </div>

                <div class="card-body p-4">
                  <app-form-setup id="discardCouponForm" [FromJson]="discardFormConfig"
                    (formEmitted)="onDiscardFormEmitted($event)" (formCheck)="onDiscardFormCheck($event)"
                    [submitForm]="callForDiscardForm">
                  </app-form-setup>

                  <div class="d-flex align-items-center justify-content-end gap-2 pt-3 border-top">
                    <button type="button" (click)="triggerDiscardSubmit()"
                      class="btn btn-danger d-inline-flex align-items-center gap-2 px-4 py-2"
                      [disabled]="isDiscarding || !siteid">
                      <span *ngIf="isDiscarding" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <i *ngIf="!isDiscarding" class="fa fa-ban"></i>
                      <span>{{ isDiscarding ? 'Discarding...' : 'Discard Coupon' }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ========================================== -->
            <!-- TAB 4: MULTIPLE DISCARD                   -->
            <!-- ========================================== -->
            <div *ngIf="tab.id === 'multiple_coupon_discard'" class="tab-pane-container fade-in">
              <div class="card coupon-card shadow-sm">
                <div class="card-header filter d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa fa-trash text-warning fs-5"></i>
                    <span class="filterspan">Discard Multiple Coupons</span>
                  </div>
                </div>

                <div class="card-body p-4">
                  <app-form-setup id="multiDiscardCouponForm" [FromJson]="multiDiscardFormConfig"
                    (formEmitted)="onMultiDiscardFormEmitted($event)" (formCheck)="onMultiDiscardFormCheck($event)"
                    [submitForm]="callForMultiDiscardForm">
                  </app-form-setup>

                  <div class="d-flex align-items-center justify-content-end gap-2 pt-3 border-top">
                    <button type="button" (click)="triggerMultiDiscardSubmit()"
                      class="btn btn-warning d-inline-flex align-items-center gap-2 px-4 py-2"
                      [disabled]="isMultiDiscarding || !siteid">
                      <span *ngIf="isMultiDiscarding" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <i *ngIf="!isMultiDiscarding" class="fa fa-trash"></i>
                      <span>{{ isMultiDiscarding ? 'Discarding...' : 'Discard Multiple' }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ========================================== -->
            <!-- TAB 5: COUPON LIST (RECORDS TABLE)        -->
            <!-- ========================================== -->
            <div *ngIf="tab.id === 'coupon_list'" class="tab-pane-container fade-in">
              <div class="card shadow-sm">
                <div class="card-header filter d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <i class="fa fa-table text-primary fs-5"></i>
                    <span class="filterspan">Coupon Records</span>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <button type="button" class="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
                      (click)="loadCouponRecords()" [disabled]="isLoadingRecords || !siteid" title="Refresh coupon records">
                      <i class="fa fa-refresh" [class.fa-spin]="isLoadingRecords"></i>
                      <span>Refresh</span>
                    </button>
                  </div>
                </div>

                <div class="card-body p-2">
                  <app-table TableHeader="Coupon Records" ExportFileName="Coupon_Records" [loader]="isLoadingRecords"
                    [totalDisplay]="false" [pageNation]="false">
                  </app-table>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
    </div>
    <button class="scroll-btn" (click)="scrollRight()" [disabled]="isAtRight" type="button" aria-label="Scroll Right">
      ▶
    </button>
  </div>

  <!-- Tab Content Outlet -->
  <div class="card-body px-0 pb-0">
    <div class="tab-content" id="coupon-pills-tabContent">
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>
</div>